import { createSlice } from '@reduxjs/toolkit';

export const TerminalDescansoslice = createSlice({
    name: 'terminalDescansos',
    initialState: {
        terminaldescansos_list: [],
        terminaldescansos: {}
    },
    reducers: {
        setTerminalsDescansosRedux: ( state, { payload } ) => {
            state.terminaldescansos_list  =  payload;
        }, 
        storeTerminalDescansosRedux: ( state, { payload } ) => {
            state.terminaldescansos  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setTerminalsDescansosRedux, storeTerminalDescansosRedux } = TerminalDescansoslice.actions;